import { useMemo } from "react";
import { useMystudioNotificationsV4 } from "../../../Common/api/v4/hooks";
import { alarmListData_Interface } from "../static/interface/AlarmList.interface";

const EMPTY_LIST: alarmListData_Interface[] = [];

function compactDate(value: string): string {
    const date = new Date(value);
    if(Number.isNaN(date.getTime())) return "";
    const pad = (part: number) => String(part).padStart(2, "0");
    return [
        date.getFullYear(),
        pad(date.getMonth() + 1),
        pad(date.getDate()),
        pad(date.getHours()),
        pad(date.getMinutes()),
        pad(date.getSeconds()),
    ].join("");
}

const useAlarmListREST = (enabled: boolean = true) => {
    const query = useMystudioNotificationsV4({ page: 1, limit: 20 }, enabled);
    const alarmListData = useMemo(() => {
        const items = query.data?.data?.items;
        if(!items) return EMPTY_LIST;
        return items.flatMap((item) => {
            const id = Number(item.id);
            if(!Number.isSafeInteger(id) || id <= 0) return [];
            return [{
                alarm_id: id,
                alarm_title: item.title,
                alarm_content: item.body,
                alarm_redirect_url: item.deepLink || "",
                alarm_insert_dt: compactDate(item.createdAt),
                alarm_read_yn: item.readAt ? 1 as const : 2 as const,
                push_history_id: id,
            }];
        });
    }, [query.data]);

    return {
        alarmListData,
        alarmListIsLoading: query.isLoading,
        alarmListError: query.error,
        alarmListRefetch: query.refetch,
    };
};

export default useAlarmListREST;
